var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.trackersToDisplay},model:{value:(_vm.localTracker),callback:function ($$v) {_vm.localTracker=$$v},expression:"localTracker"}},'v-select',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }